import { render } from "./CoordsBlock.vue?vue&type=template&id=e485747e"
import script from "./CoordsBlock.vue?vue&type=script&lang=js"
export * from "./CoordsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__